import {Bin} from '../bin';
import {Board} from '../board';
import {PlacedBin} from '../placed-bin';

export class PlaceFinder {

    constructor(
        public board: Board,
        public placedBins: PlacedBin[],
        public bin: Bin
    ) {}

    public produceVariants(): PlacedBin[] {
        // To be implemented.

        return [];
    }

}
